import { createSlice } from "@reduxjs/toolkit";

const subscriptionPlanSlice = createSlice({
  name: "subscriptionPlan",
  initialState: {
    data: [], // List of subscription plans
    total: 0,
    loading: false,
    payment_info: {},
    appSubscriptionData: [],
    appSubscriptionTotal: 0,
    allSubscriptionList: [],
    childSubscriptionData: [],
    childSubscriptionTotal: 0,
    externalSubscriptionData: [],
    benefitFeatureUpdating: false,
    benefitFeatureUpdate: null,
    benefitUsage: [],
    benefitUsageLoading: false,
    error: null,
  },
  reducers: {
    // FETCH ALL
    fetchPlansRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchPlansSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload?.data || [];
      state.total = action.payload?.total || 0;
    },
    fetchPlansFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // FETCH ALL Subscriptions From App Subscriptions
    fetchAppSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchAppSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.appSubscriptionData = action.payload?.data || [];
      state.appSubscriptionTotal = action.payload?.total || 0;
    },
    fetchAppSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // CREATE
    createPlanRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createPlanSuccess: (state, action) => {
      state.loading = false;
      state.data.push(action.payload);
    },
    createPlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // UPDATE
    updatePlanRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updatePlanSuccess: (state, action) => {
      state.loading = false;
      const index = state.data.findIndex(
        (plan) => plan._id === action.payload._id,
      );
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    updatePlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // DELETE
    deletePlanRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    deletePlanSuccess: (state, action) => {
      state.loading = false;
      state.data = state.data.filter((plan) => plan._id !== action.payload);
    },
    deletePlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    purchasePlanRequest: (state, action) => {},
    purchasePlanSuccess: (state, action) => {
      state.loading = false;
      state.payment_info = action.payload;
    },
    purchasePlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // check payment status
    checkPaymentStatusRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    checkPaymentStatusSuccess: (state, action) => {
      state.loading = false;
      state.payment_info = action.payload;
    },
    checkPaymentStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    // get active plan
    checkActivePlanRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    checkButtonRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    checkActivePlanSuccess: (state, action) => {
      state.loading = false;
      state.active_plan = action.payload;
    },
    checkActivePlanFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    purchaseDirectPlan: (state, action) => {},
    fetchSubscriptionRequest: (state) => {
      state.loading = true;
    },
    fetchSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.allSubscriptionList = action.payload.subscriptions;
      state.total = action.payload.total;
      state.message = action.payload.message;
      state.error = null;
    },
    fetchSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    manuallyExpireSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    manuallyExpireSubscriptionSuccess: (state) => {
      state.loading = false;
    },

    manuallyExpireSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    payInstallmentRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    payInstallmentSuccess: (state, action) => {
      state.loading = false;
      state.payment_info = action.payload;
    },

    payInstallmentFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchChildSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchChildSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.childSubscriptionData = action.payload?.data || [];
      state.childSubscriptionTotal = action.payload?.total || 0;
    },

    fetchChildSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    payExternalFeaturesRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    payExternalFeaturesSuccess: (state, action) => {
      state.loading = false;
      state.payment_info = action.payload;
    },
    payExternalFeaturesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchExternalSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
      state.externalSubscriptionData = [];
    },
    fetchExternalSubscriptionSuccess: (state, action) => {
      state.loading = false;
      state.externalSubscriptionData = action.payload?.data || [];
    },
    fetchExternalSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.externalSubscriptionData = [];
    },
    updateBenefitAndFeatureRequest: (state) => {
      state.benefitFeatureUpdating = true;
      state.error = null;
    },
    updateBenefitAndFeatureSuccess: (state, action) => {
      state.benefitFeatureUpdating = false;
      state.benefitFeatureUpdate = action.payload;
      const plan = action.payload?.plan;
      if (!plan?._id) return;
      const index = state.data.findIndex(
        (item) => String(item._id) === String(plan._id),
      );
      if (index !== -1) {
        state.data[index] = {
          ...state.data[index],
          features: plan.features ?? state.data[index].features,
          benefits: plan.benefits ?? state.data[index].benefits,
        };
      }
    },
    updateBenefitAndFeatureFailure: (state, action) => {
      state.benefitFeatureUpdating = false;
      state.error = action.payload;
    },
    activateHoldSubscriptionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    activateHoldSubscriptionSuccess: (state) => {
      state.loading = false;
    },
    activateHoldSubscriptionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    fetchJewellerBenefitUsageRequest: (state) => {
      state.benefitUsageLoading = true;
      state.error = null;
    },
    fetchJewellerBenefitUsageSuccess: (state, action) => {
      state.benefitUsageLoading = false;
      state.benefitUsage = action.payload || [];
    },
    fetchJewellerBenefitUsageFailure: (state, action) => {
      state.benefitUsageLoading = false;
      state.benefitUsage = [];
      state.error = action.payload;
    },
  },
});

export const {
  fetchPlansRequest,
  fetchPlansSuccess,
  fetchPlansFailure,
  fetchAppSubscriptionRequest,
  fetchAppSubscriptionSuccess,
  fetchAppSubscriptionFailure,
  createPlanRequest,
  createPlanSuccess,
  createPlanFailure,
  updatePlanRequest,
  updatePlanSuccess,
  updatePlanFailure,
  deletePlanRequest,
  deletePlanSuccess,
  deletePlanFailure,
  purchasePlanRequest,
  purchasePlanSuccess,
  purchasePlanFailure,
  checkPaymentStatusRequest,
  checkPaymentStatusSuccess,
  checkPaymentStatusFailure,
  checkActivePlanRequest,
  checkActivePlanSuccess,
  checkActivePlanFailure,
  checkButtonRequest,
  purchaseDirectPlan,
  fetchSubscriptionRequest,
  fetchSubscriptionSuccess,
  fetchSubscriptionFailure,
  manuallyExpireSubscriptionRequest,
  manuallyExpireSubscriptionSuccess,
  manuallyExpireSubscriptionFailure,
  payInstallmentRequest,
  payInstallmentSuccess,
  payInstallmentFailure,
  fetchChildSubscriptionRequest,
  fetchChildSubscriptionSuccess,
  fetchChildSubscriptionFailure,
  payExternalFeaturesRequest,
  payExternalFeaturesSuccess,
  payExternalFeaturesFailure,
  fetchExternalSubscriptionRequest,
  fetchExternalSubscriptionSuccess,
  fetchExternalSubscriptionFailure,
  updateBenefitAndFeatureRequest,
  updateBenefitAndFeatureSuccess,
  updateBenefitAndFeatureFailure,
  activateHoldSubscriptionRequest,
  activateHoldSubscriptionSuccess,
  activateHoldSubscriptionFailure,
  fetchJewellerBenefitUsageRequest,
  fetchJewellerBenefitUsageSuccess,
  fetchJewellerBenefitUsageFailure,
} = subscriptionPlanSlice.actions;
export { subscriptionPlanSlice };

export default subscriptionPlanSlice.reducer;
